// src/components/Toast.js
import React, { useContext, useEffect } from 'react';
import { AppContext } from '../context/AppContext';
import { BiX } from 'react-icons/bi';

const Toast = ({ message, type = 'success', show }) => {
    const { setToast } = useContext(AppContext);

    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                setToast({
                    message: "",
                    type: "",
                    show: false
                });
            }, 5000);

            return () => clearTimeout(timer);  // Clear timeout if the component unmounts or `show` changes
        }
    }, [show, setToast]);

    const typeStyles = {
        success: 'bg-green-500',
        error: 'bg-red-500',
        info: 'bg-blue-500',
        warning: 'bg-yellow-500',
    };

    return (
        <>
            {show && <div className="fixed top-5 right-5 space-y-2 z-[99999]">
                <div
                    className={`flex items-center justify-between p-4 rounded-lg shadow-lg text-white ${typeStyles[type]} animate-slide-in`}
                >
                    <span>{message}</span>
                    <button onClick={() => setToast({
                        message: "",
                        type: "",
                        show: false
                    })} className="ml-4 focus:outline-none">
                        <BiX className="w-5 h-5" />
                    </button>
                </div>
            </div>}
        </>
    );
};

export default Toast;
